import { Env } from "../../env";

const PREFECTURE_CODE_TOKYO = '13';

export const init = () => {
  if (Env.PAGE.userId) {
    if (Env.PAGE.oldUserId) {
      document.cookie = `_rt.uid=${encodeURIComponent(
        Env.PAGE.userId
      )}; path=/; domain=${window.location.hostname.replace(/^solution\./, '')}`;

      Rtoaster.init(Env.SETTING.rtoaster.accountId, Env.PAGE.oldUserId, Env.PAGE.userId);
    } else {
      Rtoaster.init(Env.SETTING.rtoaster.accountId, Env.PAGE.userId);
    }
  } else {
    Rtoaster.init(Env.SETTING.rtoaster.accountId);
  }
};

export const track = (appKey?: {}) => {
  if (appKey === undefined) {
    Rtoaster.track();
  } else {
    Rtoaster.track(appKey);
  }
};

export const doShowRtoaster = ({
   elementIds,
   showRtoasterAreaCallBack,
   setParametersCallBack,
   rtoasterParameter,
   categoryCodesToFilter
  }: {
     elementIds: string[],
     showRtoasterAreaCallBack: Function,
     setParametersCallBack?: Function | null,
     rtoasterParameter?: RtoasterParameter,
     categoryCodesToFilter?: CategoryCodeFilter | null
  }) => {

  const appKey = (rtoasterParameter) ? rtoasterParameter.appKeys : undefined;

  init();

  if (setParametersCallBack) setParametersCallBack(rtoasterParameter);

  track(appKey);

  // Rtoaster.flushを退避させて複数回ループさせるのを防ぐ
  if (!Rtoaster._flush_original) {
    Rtoaster._flush_original = Rtoaster.flush;
  }
  Rtoaster.flush = function (p) {
    Rtoaster._flush_original(p);
    if (!p) {
      var recommendItems = getRecommendItem(elementIds);

      recommendItems = filterNgPrefectureCode(recommendItems);

      if (categoryCodesToFilter) {
        if (categoryCodesToFilter.mCategoryCode) recommendItems = filterMCategoryCode(recommendItems, categoryCodesToFilter.mCategoryCode);
      }

      showRtoasterAreaCallBack(pickCatalogItemCode(recommendItems));
    }
  }

  Rtoaster.recommendNow(...elementIds);
};

const getRecommendItem = (elementIds: string[]) => {
  return elementIds.map(elementId => {
    const recommendItemKeyValue: RecommendItemKeyValue = {
      elementId: elementId,
      recommendItems: []
    }
    const parentElement = document.getElementById(elementId);
    if (parentElement === null) return recommendItemKeyValue;

    const recommendItemList = Array.from(parentElement.children).map(subElement => {
      return Array.from(subElement.children).map(keyValues => {
        const recommendItem: RecommendItem = {
          catalogItemCode: keyValues.getElementsByClassName('catalogItemCode').item(0)!!.textContent!!,
          ngPrefectureCode: keyValues.getElementsByClassName('ngPrefectureCode').item(0)?.textContent,
          mCategoryCode: keyValues.getElementsByClassName('mCategoryCode').item(0)?.textContent
        };
        return recommendItem;
      });
    });

    recommendItemKeyValue['recommendItems'] = [].concat.apply([], recommendItemList);
    return recommendItemKeyValue
  });
};

const filterNgPrefectureCode = (recommendItemKeyValues: RecommendItemKeyValue[]): RecommendItemKeyValue[] => {
  const recommendItemList = recommendItemKeyValues.map(recommendItemKeyValue => {
    recommendItemKeyValue.recommendItems = recommendItemKeyValue.recommendItems.filter(recommendItem => recommendItem.ngPrefectureCode !== PREFECTURE_CODE_TOKYO);
    return recommendItemKeyValue;
  });
  return recommendItemList;
}

const filterMCategoryCode = (recommendItemKeyValues: RecommendItemKeyValue[], mCategoryCode: string): RecommendItemKeyValue[] => {
  const recommendItemList = recommendItemKeyValues.map(recommendItemKeyValue => {
    recommendItemKeyValue.recommendItems = recommendItemKeyValue.recommendItems.filter(recommendItem => recommendItem.mCategoryCode === mCategoryCode);
    return recommendItemKeyValue;
  });
  return recommendItemList;
}

const pickCatalogItemCode = (recommendItemKeyValues: RecommendItemKeyValue[]): CatalogItemCodesWithElementId[] => {
  return recommendItemKeyValues.map(recommendItemKeyValue => {
    const catalogItemCodes = recommendItemKeyValue.recommendItems.map(recommendItem => recommendItem.catalogItemCode);
    const catalogItemCodesWithElementId: CatalogItemCodesWithElementId = {
      elementId: recommendItemKeyValue.elementId,
      catalogItemCodes: catalogItemCodes
    };
    return catalogItemCodesWithElementId;
  })
}

export interface CatalogItemCodesWithElementId {
  elementId: string,
  catalogItemCodes: string[]
}

interface RecommendItemKeyValue {
  elementId: string,
  recommendItems: RecommendItem[]
}

interface RecommendItem {
  catalogItemCode: string,
  ngPrefectureCode?: string | null,
  mCategoryCode?: string | null
}

export interface CategoryCodeFilter {
  mCategoryCode?: string | null
}

export interface RtoasterParameter {
  appKeys?: {},
  catalogItemCode?: string,
  catalogItemCodes?: string[],
  categoryCode?: string,
  price?: number,
}
